const resources = {
    free: 'GRATUIT',
    biFreeShip: 'Les membres Beauty Insider profitent de la *livraison standard GRATUITE* sur toutes les commandes.'
};

module.exports = function getResource(label) {
    return resources[label];
};
